import store from '@/store/index'

import { AUTH_PURGE_AUTH } from '@/store/auth/auth.types'
import { NAV_SET_MENU_OPEN, NAV_SET_SEARCH_QUERY } from '@/store/navigation/nav.types'
import { API_PURGE_RESULTS } from '@/store/api/postStatus.types'
import { SEARCH_PURGE_CATEGORIES } from '@/store/search/searchModule.types'
import { RECENT_PURGE_HISTORY } from '@/store/recent/recentHistoryModule.types'

/**
 * Resets all store state
 */
export const resetAll = () => {
  store.commit(AUTH_PURGE_AUTH)
  store.commit(NAV_SET_MENU_OPEN, false)
  store.commit(NAV_SET_SEARCH_QUERY, '')
  store.commit(API_PURGE_RESULTS)
  store.commit(SEARCH_PURGE_CATEGORIES)
  store.commit(RECENT_PURGE_HISTORY)

  store.commit('settings/reset')

  store.commit('account/userRegisterModule/reset')
  store.commit('account/userRegisterModule/resetForm')

  store.commit('dashboards/dashboardsModule/reset')
  store.commit('dashboards/dashboardsModule/resetForm')

  store.commit('admin/accountTypesModule/resetForm')
  store.commit('admin/accountTypesModule/reset')
  store.commit('admin/partnersModule/reset')
  store.commit('admin/agenciesModule/reset')
  store.commit('admin/agenciesModule/resetForm')
  store.commit('admin/clientsModule/reset')
  store.commit('admin/clientsModule/resetForm')
  store.commit('admin/findClientsWidgetModule/purge')
  store.commit('admin/findAgenciesWidgetModule/purge')
  store.commit('admin/findPartnersWidgetModule/purge')
  store.commit('admin/usersModule/reset')
  store.commit('admin/usersModule/resetForm')
  store.commit('admin/usersProfileModule/reset')
  store.commit('admin/usersProfileModule/resetForm')

  store.commit('assets/driversModule/reset')
  store.commit('assets/driversModule/resetForm')
  store.commit('assets/vehiclesModule/reset')
  store.commit('assets/vehiclesModule/resetForm')
  store.commit('assets/vehicleGroupsModule/reset')
  store.commit('assets/vehicleGroupsModule/resetForm')
  store.commit('assets/findVehiclesWidgetModule/purge')
  store.commit('assets/findVehicleGroupsWidgetModule/purge')

  store.commit('units/unitsModule/reset')
  store.commit('units/unitsModule/resetForm')
  store.commit('units/unitArchivesModule/reset')
  store.commit('units/unitSwappingModule/reset')
  store.commit('units/unitGroupsModule/reset')
  store.commit('units/unitGroupsModule/resetForm')
  store.commit('units/cfgTemplatesModule/reset')
  store.commit('units/cfgTemplatesModule/resetForm')
  store.commit('units/findUnitsWidgetModule/purge')

  store.commit('events/eventProfilesModule/reset')
  store.commit('events/findEventProfilesWidgetModule/purge')
  store.commit('events/eventPoolsModule/reset')
  store.commit('events/findEventPoolsWidgetModule/purge')
  store.commit('events/findWsEventPoolsWidgetModule/purge')
  store.commit('events/eventMonitoringModule/reset')

  store.commit('monitoring/monitoringModule/reset')
  store.commit('monitoring/widgetControlModule/reset')
  store.commit('monitoring/liveTrackingWidgetModule/purge')
  store.commit('monitoring/tripReplayWidgetModule/reset')
  store.commit('monitoring/positionReplayWidgetModule/reset')

  store.commit('zones/findZonesWidgetModule/purge')
  store.commit('zones/zonesModule/reset')

  store.commit('reports/reportsModule/reset')
  store.commit('reports/reportsModule/resetForm')

  store.commit('simCards/simCardsModule/reset')
  store.commit('simCards/simCardsModule/resetForm')
}



// WEBPACK FOOTER //
// ./src/store/reset.js